import { BookingRecordCreate } from '@navio/nsdk';
import { NoddiAsyncError, TireHotelLocationSuggestion, TireHotelPickupDecision } from 'noddi-types';

const WHEEL_PICKUP_LOCATION_SUGGESTION_CODE = 'wheel_pickup_location_suggestion';

/**
 * Candidates when booking creation failed with wheel_pickup_location_suggestion, else empty. Read from the untyped
 * error_context envelope (snake_case), so malformed entries are dropped.
 */
export const getTireHotelLocationSuggestions = (error: NoddiAsyncError | null): TireHotelLocationSuggestion[] => {
  const data = error?.response?.data;
  if (!data?.errors?.some(({ code }) => code === WHEEL_PICKUP_LOCATION_SUGGESTION_CODE)) {
    return [];
  }
  const candidates: unknown = data.error_context?.tire_hotel_locations;
  if (!Array.isArray(candidates)) {
    return [];
  }
  return candidates.flatMap((candidate) => {
    if (typeof candidate !== 'object' || candidate === null) {
      return [];
    }
    const { tire_hotel_location_id, name, address } = candidate as Record<string, unknown>;
    if (typeof tire_hotel_location_id !== 'number' || typeof name !== 'string') {
      return [];
    }
    return [{ tireHotelLocationId: tire_hotel_location_id, name, address: typeof address === 'string' ? address : '' }];
  });
};

/** The failed booking payload with the decision on every custom-address pickup (the backend error does not name the car). */
export const withTireHotelPickupDecision = (
  payload: BookingRecordCreate,
  decision: TireHotelPickupDecision
): BookingRecordCreate => ({
  ...payload,
  cars: payload.cars.map((car) =>
    car.wheelPickup?.addressPickupId && !car.wheelPickup.tireHotelLocationId
      ? { ...car, wheelPickup: { ...car.wheelPickup, ...decision } }
      : car
  )
});
